import Observer from 'common/scripts/observer';
import Utils from 'common/scripts/utils';

const observer = new Observer();
const TARGET_SELECTOR = '.j-favorite-btn';
const OPTIONS_SELECTOR = '.j-favorite-options';
const OPTIONS_MORE_CLASS = 'j-favorite-options-more';
const ZOOM_CLASS = 'j-favorite-zoom';
const ACTIVE_CLASS = 'is-active';

class Favorite {
    /**
     * Метод инициализирует модуль
     * @param {object} options - настройки
     */
    init(options) {
        this.elem = document;
        this.isFavoritePage = options.isFavoritePage || false;
        this.results = [];

        this._getElements();
        this._bindContext();
        this._subscribes();
        this._bindEvents();
        this._setResults();
        this._updateCounter();
    }

    /**
     * Метод получает элементы
     * @private
     */
    _getElements() {
        this.targets = Array.from(document.querySelectorAll(TARGET_SELECTOR));
        this.header = document.querySelector('.j-header-favorite');
        this.counters = Array.from(document.querySelectorAll('.j-favorite-count'));
        this.cards = Array.from(this.elem.querySelectorAll('.j-favorite-card'));
        this.resetButton = this.elem.querySelector('.j-popup-reset');
        this.container = this.elem.querySelector('.j-favorite-results');
        this.plug = this.elem.querySelector('.j-favorite-plug');
        this.list = this.elem.querySelector('.j-favorite-list');

        if (this.isFavoritePage) {
            this.favoriteContainer = document.querySelector('.j-favorite');

            const pluralBase64 = this.favoriteContainer.dataset.plural;

            this.plural = JSON.parse(window.atob(pluralBase64));
        }
    }

    /**
     * Метод привязывает контекст
     * @private
     */
    _bindContext() {
        this._onClick = this._onClick.bind(this);
        this._resetAll = this._resetAll.bind(this);
        this._scrollListener = this._scrollListener.bind(this);
    }

    /**
     * Метод навешивает обработчики событий
     * @private
     */
    _bindEvents() {
        const cookies = Utils.getCookie('fav_f');

        this.results = cookies;

        this.targets.forEach((target) => {
            if (!target.bindClick) {
                target.addEventListener('click', this._onClick);
                target.bindClick = true;
            }
        });

        if (cookies && document.querySelector('.j-favorite-flat')) {
            const flatBtn = document.querySelector('.j-favorite-btn');
            const flatBtnId = flatBtn.dataset.id;

            if (cookies.match(flatBtnId)) {
                flatBtn.classList.add(ACTIVE_CLASS);
            }
        }

        this.cards.forEach((item) => {
            item.addEventListener('click', (event) => {
                if (event.target.classList.contains(OPTIONS_MORE_CLASS) ||
                    event.target.closest(OPTIONS_MORE_CLASS)) {
                    if (!Utils.isBreakpoint(0, 1280)) {
                        return;
                    }

                    event.preventDefault();

                    const element = event.target.closest(OPTIONS_SELECTOR);

                    if (element) {
                        element.classList.toggle(ACTIVE_CLASS);
                    }

                    window.addEventListener('scroll', this._scrollListener);
                } else if (event.target.classList.contains(ZOOM_CLASS) ||
                    event.target.closest(`.${ZOOM_CLASS}`)) {
                    event.preventDefault();
                }
            });
        });
    }

    /**
     * Метод подписывается на события в других компонентах
     * @private
     */
    _subscribes() {
        observer.subscribe('reset-favorite', () => {
            this._resetAll();
        });

        observer.subscribe('favorite-parametric', (id) => {
            if (this.results.includes(id)) {
                const newResults = this.results.filter((item) => {
                    return item !== id;
                });

                this.results = newResults;
            } else {
                this.results.push(id);
            }

            this._setCookie();
            this._updateCounter();
        });
    }

    /**
     * Метод записывает в массив с результатами данные из куки
     * @private
     */
    _setResults() {
        const cookies = Utils.getCookie('fav_f');

        this.results = [];

        if (cookies) {
            this.results = cookies.replace(/\s/g, '').split(',');
        }
    }

    /**
     * Обработчик клика на кнопку
     * @param {Object} event - объект события
     * @private
     */
    _onClick(event) {
        event.preventDefault();
        event.stopPropagation();

        this.target = event.target.closest(TARGET_SELECTOR);
        this.id = String(this.target.dataset.id);

        if (this.target.classList.contains(ACTIVE_CLASS)) {
            this._removeActive();
        } else {
            this._setActive();
        }

        this._setCookie();
        this._updateCounter();
    }

    /**
     * Метод очищает всё избранное
     * @private
     */
    _resetAll() {
        this.results = [];
        this._setCookie();

        if (this.isFavoritePage) {
            this._removeAllItems();
        }

        this._showPlug();
        this._updateCounter();
    }

    /**
     * Метод устанавливает кнопке активный класс и добавляет id в массив с результатами
     * @private
     */
    _setActive() {
        this.target.classList.add(ACTIVE_CLASS);
        this._setResults();
        this.results.push(this.id);
    }

    /**
     * Метод убирает активный класс и возвращает новый массив с результатами без того, на котором произошло событие
     * @private
     */
    _removeActive() {
        this.target.classList.remove(ACTIVE_CLASS);
        this._setResults();

        this.results = this.results.filter((item) => {
            return item !== this.id;
        });

        if (this.isFavoritePage) {
            this._removeItem();
        }
    }

    /**
     * Метод удаляет квартиру из списка избранного
     * @private
     */
    _removeItem() {
        const cards = Array.from(this.elem.querySelectorAll(`.parametric-card[data-id="${this.id}"]`));

        cards.forEach((card) => {
            Utils.removeElement(card.closest('.parametric-card') || card);
        });

        this._updateCounter();
        this._checkHasFlats();
    }

    /**
     * Метод проверяет, остались ли на странице избранного квартиры
     */
    _checkHasFlats() {
        const cards = Array.from(this.elem.querySelectorAll('.parametric-card'));

        if (!cards.length) {
            this._showPlug();
        }
    }

    /**
     * Удаляет все квартиры из списка на страницу избранного
     * @private
     */
    _removeAllItems() {
        this.cards.forEach((card) => {
            Utils.removeElement(card.closest('.parametric-card') || card);
        });

        this._showPlug();
    }

    /**
     * Метод обновляет цифру в счётчиках
     * @private
     */
    _updateCounter() {
        if (!this.counters.length) {
            return;
        }

        this.counters.forEach((item) => {
            const pluralSpan = item.querySelector('span.j-favorite-plural');

            if (pluralSpan) {
                const text = Utils.pluralWord(this.results.length, this.plural);

                item.innerHTML = `${this.results.length} <span class="j-favorite-plural">${text}</span>`;
            } else {
                item.textContent = this.results.length;
            }

            if (this.results.length > 0) {
                item.classList.add(ACTIVE_CLASS);
            } else {
                item.classList.remove(ACTIVE_CLASS);
            }
        });
    }

    /**
     * Метод показывает заглушку для пустого избранного и скрывает блок результатов
     * @private
     */
    _showPlug() {
        this.resetButton.classList.add('is-disabled');
        this.plug.classList.add(ACTIVE_CLASS);
        this.list.classList.remove(ACTIVE_CLASS);
    }

    /**
     * Метод записывает массив с результатами в куки
     * @private
     */
    _setCookie() {
        const now = new Date();

        now.setMonth(now.getMonth() + 1);

        const expire = now.toUTCString();

        Utils.setCookie('fav_f', this.results.toString(), {expires: expire});
    }

    _scrollListener() {
        const options = [...document.querySelectorAll(`${OPTIONS_SELECTOR}.${ACTIVE_CLASS}`)];

        options.forEach((item) => {
            item.classList.remove(ACTIVE_CLASS);
        });

        window.removeEventListener('scroll', this._scrollListener);
    }
}

export default Favorite;
